import React, { createContext, useMemo, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { GradeConversion, useGradeConversion } from '../data/useGradeConversion';

export interface GradeConversionDetails {
  conversionTable: GradeConversion | undefined;
  isLoadingConversionTable: boolean;
  isFetchingConversionTable: boolean;
  conversionTableError: unknown;
  isConversionTableError: boolean;
}

const gradeConversionDetailsContext = createContext<GradeConversionDetails | undefined>(undefined);

export const GradeConversionDetailsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const id = useParams().id as string;

  const {
    isLoadingConversionTable,
    isFetchingConversionTable,
    conversionTableError,
    conversionTable,
    isConversionTableError,
  } = useGradeConversion(id);

  const value = useMemo(
    () => ({
      conversionTable,
      isLoadingConversionTable,
      isFetchingConversionTable,
      conversionTableError,
      isConversionTableError,
    }),
    [conversionTable, isLoadingConversionTable, isFetchingConversionTable, conversionTableError, isConversionTableError]
  );

  return <gradeConversionDetailsContext.Provider value={value}>{children}</gradeConversionDetailsContext.Provider>;
};

export const useGradeConversionDetails = () => {
  const context = useContext(gradeConversionDetailsContext);
  if (!context) {
    throw new Error('useGradeConversionDetails must be used within GradeConversionDetailsContextProvider');
  }
  return context;
};
